
import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import headerImg from "../assets/img/header-img.svg";
import { ArrowRightCircle } from "react-bootstrap-icons";

export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState("");
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const [index, setIndex] = useState(1);
  const toRotate = ["Software Engineer", "React Js Developer"];
  const period = 2000;

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => {
      clearInterval(ticker);
    };
  }, [text]);

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting
      ? fullText.substring(0, text.length - 1)
      : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta((prevDelta) => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setIndex((prevIndex) => prevIndex - 1);
      setDelta(period);
    } else if (isDeleting && updatedText === "") {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setIndex(1);
      setDelta(500);
    } else {
      setIndex((prevIndex) => prevIndex + 1);
    }
  };

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="aligh-items-center">
          <Col
            xs={12}
            md={6}
            xl={7}
            className="wow fadeIn"
            dataWowDuration="1.5s"
          >
            <span className="tagline">Welcome to my Portfolio</span>
            <h1>
              {`Hi! I'm Tayyab Raja`}{" "}
              <span
                className="txt-rotate"
                dataPeriod="1000"
                data-rotate='[ "Software Engineer", "React JS Developer" ]'
              >
                <span className="wrap">{text}</span>
              </span>
            </h1>
            <p>
              My interest lie in Web Developement. I have a creative mind, an
              excellent analytical skills and a strong ability to solve
              problems, provding you the best website developemnt using React JS
              / Next Js
            </p>
            <h5 style={{ display: "flex" }}>
              Email : tayyabraja316@gmail.com
            </h5>
            <h5 style={{ display: "flex" }}>
              Contact : +92-309-332-3232
            </h5>
            <button onClick={() => console.log("connect")}>
              Let’s Connect <ArrowRightCircle size={25} />
            </button>
          </Col>
          <Col
            xs={12}
            md={6}
            xl={5}
            className="wow zoomIn"
            dataWowDuration="1.5s"
          >
            <img src={headerImg} alt="Header Img" />
          </Col>
        </Row>
      </Container>
    </section>
  );
};
